var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
    'header',
    _vm.isSmall && 'header--small',
  ]},[_c('IconButton',{style:({ visibility: _vm.router.canGoBack ? '' : 'hidden' }),attrs:{"icon":"arrow_back","size":_vm.isSmall ? 'small' : 'normal'},on:{"click":() => _vm.router.goBack()}}),(_vm.title)?_c('div',{staticClass:"title"},[_c('h1',[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_c('IconButton',{attrs:{"icon":"close","size":_vm.isSmall ? 'small' : 'normal'},on:{"click":() => _vm.userStore.hideLoginDialog({ dismissed: true })}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }